import React from "react";

import "../styles.scss";
import "../scripts";

import {
  footerBlock,
  FooterBlockConfig,
  getDefaultProps,
  KameleonElement,
  BlockTheme,
  MenuItem,
  BlockAsProp,
  renderWidgetBlock,
} from "@kameleon-core/lib";

import { Box, Link } from "theme-ui";
import { KameleonIcon } from "@kameleon-common/icons";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { DefaultType, layoutOptions, SocialIcon } from "./types/prop-types";

/** Default Footer */
const blockConfig: FooterBlockConfig = {
  blockTheme: BlockTheme.light,
};

export const Default = footerBlock<DefaultType>(
  blockConfig,
  ({
    FooterWidgetBlocks,
    logo,
    bottomLinks,
    copyright,
    bottomIcons,
    layoutProps,
  }: DefaultType) => {
    const bottomItems = bottomLinks.length || bottomIcons.length || copyright;

    return (
      <Box className="footer-default-four-col-logo-left-v1">
        <div className="container-large">
          <div className="padding-vertical padding-xxlarge">
            <div
              className={`padding-bottom${bottomItems && " padding-xxlarge"}`}
            >
              <div className="footer5_top-wrapper">
                <a href="/" className="footer5_logo-link">
                  <Variants.Logo src={logo.url} alt={logo.alt} />
                </a>
                {FooterWidgetBlocks &&
                  FooterWidgetBlocks?.map(
                    (FooterBlockWidget: BlockAsProp, i: number) => (
                      <div key={i}>{renderWidgetBlock(FooterBlockWidget)}</div>
                    )
                  )}
              </div>
            </div>
            {bottomItems && (
              <Variants.DividerHorizontal className="line-divider" />
            )}
            {bottomItems && (
              <div className="padding-top padding-medium">
                <div className="footer5_bottom-wrapper">
                  <div className="footer5_legal-list">
                    {copyright && (
                      <div className="footer5_credit-text">
                        ©{" "}
                        {layoutProps.dynamicCopyright &&
                          new Date().getFullYear()}{" "}
                        {copyright}
                      </div>
                    )}
                    {bottomLinks.map(({ label, link }: MenuItem, index) => (
                      <Link
                        key={`bottom-links-${index}`}
                        id={`footer-bottom-link__${label}`}
                        href={link}
                        className="footer5_legal-link"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                  <div className="footer5_social-icons">
                    {bottomIcons.map(({ url, icon }: SocialIcon, index) => (
                      <Link
                        key={`bottom-icons-${index}`}
                        id={`footer-bottom-icon__${icon}`}
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <KameleonIcon name={icon} />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Box>
    );
  }
);

Default.defaultProps = getDefaultProps<DefaultType>(defaults);

export const Element: KameleonElement = {
  component: Default,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
